import request from "@/api/request";

//wifi详情
export function getEquipment(a) {
  return request({
    url: `/app/equipment/getEquipment?iccId=${a}`,
  });
}

//wifi修改
export function updatePwdAndName(data) {
  return request({
    url: `/app/equipment/updatePwdAndName`,
    method: "post",
    data,
  });
}
//wifi重启
export function reconnection(a) {
  return request({
    url: `/app/equipment/reconnection?imei=${a}`,
  });
}

//wifi恢复出场设置
export function init(a) {
  return request({
    url: `/app/equipment/init?imei=${a}`,
  });
}

//上游实名地址
export function realAddress(data) {
  return request({
    url: `/app/realName/getUrl?card=${data}`,
  });
}

//第三方实名地址
export function getThirdPartyUrl(data) {
  return request({
    url: `/app/realName/getThirdPartyUrl?card=${data}`,
  });
}

//设置
export function getAll() {
  return request({
    url: `/app/systemSettings/getAll`,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

//微信支付
export function weixinSetMeal(a, s, d, f) {
  return request({
    url: `/app/payWeixin/weixinSetMeal?card=${localStorage.getItem(
      "meCardNum"
    )}&mealId=${Number(
      localStorage.getItem("meal")
    )}&payId=${a}&code=${s}&next=${d}&payType=${f}`,
  });
}
